import { render } from "./KlaviyoIntegration.vue?vue&type=template&id=c5f88b64&scoped=true"
import script from "./KlaviyoIntegration.vue?vue&type=script&lang=js"
export * from "./KlaviyoIntegration.vue?vue&type=script&lang=js"

import "./KlaviyoIntegration.vue?vue&type=style&index=0&id=c5f88b64&scoped=true&lang=css"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f88b64"]])

export default __exports__